import { Link } from 'expo-router';

import { Text, createMqStyles, tokens } from '@fhs/ui';
import { REGIONS } from '@fhs-legacy/frontend/src/state/intl/types';
import { region } from '@fhs-legacy/frontend/src/utils/environment';

function getRegionalizedPhoneNumber() {
  switch (region()) {
    case REGIONS.US:
      return '79351';
    case REGIONS.CA:
      return '34782';
    default:
      return 'XXXXX';
  }
}

export function LegalDisclaimer() {
  const styles = useMqStyles();
  return (
    <Text style={styles.legalDisclaimers}>
      {`By entering your phone number and pressing ’Continue’ you consent to receive a one-time passcode via SMS from Firehouse Subs. Message and data rates may apply. You can reply HELP to ${getRegionalizedPhoneNumber()} or contact guestservices@firehousesubs.com for help.\n`}
      <Link style={styles.link} href={'/terms-of-service'}>
        Terms & Conditions
      </Link>
      {' and '}
      <Link style={styles.link} href={'/privacy-policy'}>
        Privacy Policy
      </Link>
    </Text>
  );
}

const useMqStyles = createMqStyles({
  legalDisclaimers: {
    $base: {
      fontSize: 12,
      textAlign: 'left',
      padding: 16,
      marginVertical: 16,
      borderWidth: 1,
      borderRadius: 4,
      borderColor: tokens.colors.$blackOpacity10,
      color: tokens.colors.$disabledText,
    },
    $ltDesktop: {
      fontSize: 10,
    },
  },
  link: {
    $base: {
      textDecorationLine: 'underline',
    },
  },
});
